// extracted by mini-css-extract-plugin
export default {"main":"Integrations_main__B44gv","title":"Integrations_title__26qPY","row-wrap":"Integrations_row-wrap__FvaFV","tile":"Integrations_tile__xUF1C"};